import { Box, Stepper, StepLabel } from '@mui/material'
import styled, { css } from 'styled-components'
import { TypographyComponent } from '../Typography'

export const ContentBox = styled(Box)(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: ${theme.layout.margin.big};
  `
)

export const ContainerStepper = styled(Stepper)(
  () => css`
    && {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  `
)

export const LabelStep = styled(StepLabel)(
  ({ theme }) => css`
    && {
      .MuiStepLabel-labelContainer {
        .Mui-completed {
          color: ${theme.colors.primary.main};
          font-weight: 700;
        }
        .Mui-active {
          color: ${theme.colors.primary.main};
          font-weight: 700;
        }
        .MuiStepLabel-label {
          font-size: ${theme.typograph.fontsize.h3};
          @media (max-width: ${theme.screen.medium}) {
            display: none;
          }
        }
      }

      .MuiStepLabel-iconContainer {
        .Mui-completed {
          color: ${theme.colors.primary.main} !important;
        }
        .Mui-active {
          color: ${theme.colors.base.white} !important;
          border-color: ${theme.colors.primary.main} !important;
          .MuiStepIcon-text {
            fill: ${theme.colors.primary.main} !important;
          }
        }
        .MuiSvgIcon-root {
          width: ${theme.typograph.fontsize.h9};
          height: ${theme.typograph.fontsize.h9};
          color: #fff;
          border: 1px solid ${theme.colors.base.gray100};
          border-radius: 50%;

          .MuiStepIcon-text {
            font-size: ${theme.typograph.fontsize.h3};
            fill: ${theme.colors.base.gray100};
          }
        }
      }
    }
  `
)

export const Container = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.gap.medium};
  `
)

export const Text = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      display: none;

      @media (max-width: ${theme.screen.small}) {
        display: block;
        color: ${theme.colors.primary.main};
        font-size: ${theme.typograph.fontsize.h4};
        font-weight: 700;
      }
    }
  `
)
